import { Libraries, useJsApiLoader } from "@react-google-maps/api";
import { googleMapDarkModeId, googleMapId, googleMapKey } from "common/config";

// "marker" is required for google.maps.marker.AdvancedMarkerElement (Advanced Markers path).
// "geometry" is used by distance / bounds calculations across the app.
const mapLibraries: Libraries = ["geometry", "marker"];

export function useLoadGoogleMaps() {
  const { isLoaded } = useJsApiLoader({
    id: "google-maps-script",
    mapIds: [googleMapDarkModeId, googleMapId],
    googleMapsApiKey: googleMapKey,
    libraries: mapLibraries,
    version: "3.55",
  });

  return {
    isMapsLoaded: isLoaded,
  };
}
